module.exports = __webpack_public_path__ + "img/logo.c872a521.png";